import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Button } from '@outdoor-voices/ui';
import { memo, useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { COMING_SOON } from '../../product/constants';
import { getSizeUrgencyMessage } from '../../product/utils';
import { TEXT } from '../../../config/constants';
import { wishListColorwayQuery, withListItemDeleteMutation } from './queries';
import addToCart from '../../../utils/cart/addToCart';
import css from './Item.module.scss';
import Image from '../../../components/Image';
import OVIDClient from '../../customers/OVIDClient';
import Price from '../../../components/Price';
import SelectAdvanced from '../../../components/SelectAdvanced';
import Trash from '../../../components/icons/Trash';
import WishListCache from '../../customers/WishListCache';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Loading = function Loading() {
  return /*#__PURE__*/_jsxs("div", {
    "aria-busy": "true",
    className: css.item,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.image,
      children: "\xA0"
    }), /*#__PURE__*/_jsx("h2", {
      className: css.itemTitle,
      children: "\xA0"
    }), /*#__PURE__*/_jsx("h3", {
      className: css.itemSubTitle,
      children: "\xA0"
    }), /*#__PURE__*/_jsx("div", {
      className: css.itemPrice,
      children: "\xA0"
    })]
  });
};

var SHAKE_CLASS = 'shake-animation';

var Item = function Item(_ref) {
  var _assets$edges$;

  var emsColorwayGid = _ref.emsColorwayGid,
      emsProductGid = _ref.emsProductGid,
      id = _ref.id,
      onDelete = _ref.onDelete;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      adding = _useState2[0],
      setAdding = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      deleted = _useState4[0],
      setDeleted = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      selectSizeOn = _useState6[0],
      setSelectSizeOn = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      shake = _useState8[0],
      setShake = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      size = _useState10[0],
      setSize = _useState10[1];

  var errorMessageRef = useRef(null);
  var _TEXT$inventory = TEXT.inventory,
      comingSoon = _TEXT$inventory.comingSoon,
      soldOut = _TEXT$inventory.soldOut;

  var _useQuery = useQuery({
    query: wishListColorwayQuery,
    variables: {
      id: emsColorwayGid
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  useEffect(function () {
    if (!shake) {
      return;
    }

    var timeout = setTimeout(function () {
      setShake(false);
    }, 2000);
    return function () {
      clearTimeout(timeout);
    };
  }, [shake]);

  if (fetching) {
    return /*#__PURE__*/_jsx(Loading, {});
  }

  var colorway = data.colorway;
  var variantStacks = colorway ? colorway.variantStacks : [];
  var variant = variantStacks.length !== 0 ? variantStacks[0].variant : null;

  if (!colorway || !variant) {
    console.error('We do not have that', emsColorwayGid);

    if (onDelete) {
      var ovIDClient = new OVIDClient();
      ovIDClient.mutate(withListItemDeleteMutation, {
        id: id
      });
    }

    return /*#__PURE__*/_jsx("div", {
      className: css.item,
      children: "We\u2019re sorry, but we could not load this item, so we removed it for you. Perhaps it\u2019s no longer in our catalog?"
    });
  }

  var assets = colorway.assets,
      available = colorway.available,
      color = colorway.color,
      product = colorway.product,
      waitlistType = colorway.waitlistType;
  var asset = ((_assets$edges$ = assets.edges[0]) === null || _assets$edges$ === void 0 ? void 0 : _assets$edges$.node) || false;
  var options = variantStacks.map(function (_ref2) {
    var size = _ref2.size,
        variant = _ref2.variant;
    return {
      disabled: !variant.available,
      label: size,
      value: String(variant.shopifyId),
      optMessage: getSizeUrgencyMessage(variant.inventoryQuantity)
    };
  });
  var hasMoreThanOneOption = options.length > 1;

  var onAddToBag = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var client, response, cache;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(hasMoreThanOneOption && size === '')) {
                _context.next = 5;
                break;
              }

              errorMessageRef.current.focus();
              setSelectSizeOn(true);
              setShake(true);
              return _context.abrupt("return");

            case 5:
              setAdding(true);
              addToCart({
                emsColorwayGid: emsColorwayGid,
                emsProductGid: emsProductGid,
                variantId: hasMoreThanOneOption ? size : variant.shopifyId,
                title: product.title,
                price: variant.price
              });

              if (!onDelete) {
                _context.next = 15;
                break;
              }

              client = new OVIDClient();
              _context.next = 11;
              return client.mutate(withListItemDeleteMutation, {
                id: id
              });

            case 11:
              response = _context.sent;
              cache = new WishListCache();
              cache.update(response.data.wishListItemDelete);
              setDeleted(true);

            case 15:
              setAdding(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onAddToBag() {
      return _ref3.apply(this, arguments);
    };
  }();

  var onChange = function onChange(newSize) {
    setSelectSizeOn(false);
    setSize(String(newSize));
  };

  var openSelect = function openSelect() {
    document.querySelector("#wishlit-item-".concat(id, "-button")).click();
  };

  var selectLabel = "Select size for ".concat(product.title, " in ").concat(color);
  var unavailableLabel = waitlistType === COMING_SOON ? comingSoon : soldOut;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("a", {
      className: cc([css.item, _defineProperty({}, css.unavailable, !available && waitlistType !== COMING_SOON || deleted)]),
      href: "".concat(product.absoluteUrl, "?variant=").concat(variant.shopifyId),
      children: [asset && /*#__PURE__*/_jsx("div", {
        className: css.image,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, asset.image), {}, {
          sizes: [180, 320, 448]
        }))
      }), /*#__PURE__*/_jsxs("h2", {
        className: css.title,
        children: [product.title, !available && /*#__PURE__*/_jsxs("em", {
          children: [" - ", unavailableLabel]
        })]
      }), /*#__PURE__*/_jsx("h3", {
        className: css.subTitle,
        children: color
      }), /*#__PURE__*/_jsx("div", {
        className: css.price,
        children: /*#__PURE__*/_jsx(Price, {
          compareAtPrice: variant.compareAtPrice,
          price: variant.price
        })
      })]
    }), deleted && /*#__PURE__*/_jsx("p", {
      className: css.added,
      children: "Added to Bag"
    }), available && !deleted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [hasMoreThanOneOption && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: cc([css.select, _defineProperty({}, SHAKE_CLASS, shake)]),
          children: /*#__PURE__*/_jsx(SelectAdvanced, {
            ariaLabel: selectLabel,
            compact: true,
            id: "wishlit-item-".concat(id),
            label: "Select your size",
            name: selectLabel,
            options: options,
            itemDisabledLabel: 'Sold Out',
            onChange: onChange,
            short: true,
            value: size
          })
        }), /*#__PURE__*/_jsx("div", {
          className: css.selectSizeWrap,
          children: /*#__PURE__*/_jsx("button", {
            className: cc([css.selectSize, _defineProperty({}, css.on, selectSizeOn)]),
            onClick: openSelect,
            ref: errorMessageRef,
            tabIndex: selectSizeOn ? '0' : '-1',
            type: "button",
            children: "Select a Size"
          })
        })]
      }), /*#__PURE__*/_jsx(Button, {
        ariaLabel: "Click to add ".concat(product.title, " in ").concat(color, " to your bag"),
        "data-ov-event": "add-to-bag",
        bordered: true,
        disabled: adding,
        onClick: onAddToBag,
        children: adding ? 'Adding to Bag' : TEXT.addToBag
      })]
    }), onDelete && !deleted && /*#__PURE__*/_jsx("button", {
      "aria-label": "Click to delete ".concat(product.title, " from your wish list"),
      className: css.delete,
      onClick: function onClick() {
        onDelete({
          id: id,
          colorway: colorway
        });
      },
      type: "button",
      children: /*#__PURE__*/_jsx("div", {
        className: css.icon,
        children: /*#__PURE__*/_jsx(Trash, {})
      })
    })]
  });
};

var itemProps = {
  emsColorwayGid: PropTypes.string.isRequired,
  emsProductGid: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onDelete: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired
};
Item.propTypes = itemProps;

var ItemInView = function ItemInView(props) {
  var _useInView = useInView({
    rootMargin: '350px 0px',
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    children: [!inView && /*#__PURE__*/_jsx(Loading, {}), inView && /*#__PURE__*/_jsx(Item, _objectSpread({}, props))]
  });
};

ItemInView.propTypes = itemProps;
export default /*#__PURE__*/memo(ItemInView);